<template>
  <div>
    <el-form
      role="form"
      class=""
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="relative mb-4">
        <small class="fsize12 bg-white font-medium text-dark"
          >Product Name</small
        >
        <el-input
          placeholder="Enter or Type..."
          v-model="productDetail.productName"
          class="rounded-xl mt-2"
          disabled
        />
      </div>
      <div>
        <small class="fsize12 font-semibold bg-white text-dark">{{
          productDetail.attributesId && productDetail.attributesId.length > 0
            ? productDetail.attributesId[0].name
            : "Attribute Name"
        }}</small>
        <div class="mt-1 flex gap-2">
          <el-form-item class="w-full custelitem" prop="attributeVal">
            <el-select
              multiple
              filterable
              default-first-option
              v-model="ruleForm.attributeVal"
              placeholder="Enter or Type..."
              class="w-full mt-2"
            >
              <el-option
                v-for="(att, index) in productDetail.productImageId"
                :key="`${att.valueName} + ${index}`"
                :label="att.valueName"
                :value="att.valueName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="flex gap-2 flex-wrap" v-if="varientSKU.length > 0">
        <el-tag
          class="light-purplebgtext border-none skutag"
          v-for="(att, index) in varientSKU"
          :key="`${att} + ${index}`"
          >{{ att.SKU }}</el-tag
        >
      </div>
      <div class="mt-1">
        <small class="fsize12 font-semibold bg-white text-dark">{{
          productDetail.attributesId && productDetail.attributesId.length > 0
            ? productDetail.attributesId[1].name
            : "Variation Name"
        }}</small>
        <div class="mt-1 flex gap-2">
          <el-form-item class="w-full" prop="varientVal">
            <el-input
              placeholder="Enter or Type Variation Value..."
              v-model="ruleForm.varientVal"
              class="rounded-xl mt-2"
              @change="createSKU"
            />
          </el-form-item>
        </div>
      </div>
      <div class="">
        <small class="fsize12 font-semibold bg-white text-dark">stock</small>
        <div class="mt-1 flex gap-2">
          <el-form-item class="w-full" prop="stock">
            <el-input
              placeholder="Enter or Type Stock Value..."
              v-model="ruleForm.stock"
              class="rounded-xl mt-2"
            />
          </el-form-item>
        </div>
      </div>

      <div class="flex items-center gap-6 grid-cols-2">
        <div class="w-full">
          <small class="fsize12 font-semibold bg-white text-dark">Price</small>
          <div class="mt-1 flex gap-2">
            <el-form-item class="w-full" prop="varientPrice">
              <el-input
                placeholder="Enter or Type Price..."
                v-model="ruleForm.varientPrice"
                class="rounded-xl mt-2"
              />
            </el-form-item>
          </div>
        </div>

        <div class="w-full">
          <small class="fsize12 font-semibold bg-white text-dark"
            >Discount</small
          >
          <el-form-item class="w-full" prop="varientDiscount">
            <el-input
              placeholder="Enter %..."
              v-model="ruleForm.varientDiscount"
              @input="calDiscountedPrice"
              class="rounded-xl mt-2"
              :maxlength="2"
            />
          </el-form-item>
        </div>
      </div>
      <div class="flex gap-2 flex-wrap" v-if="ruleForm.varientDiscount">
        <small class="fsize12 font-semibold bg-white text-dark"
          >Price after Discount</small
        >
        <el-tag class="light-purplebgtext border-none skutag">{{
          varientDiscountedPrice
        }}</el-tag>
      </div>

      <div class="grid grid-cols-2 gap-4 mt-8">
        <vs-button
          type="primary"
          class="bg-primary rounded-lg font-semibold py-4 fsize14"
          @click="handleSubmit('ruleForm')"
          >Save</vs-button
        >

        <vs-button
          type="secondary"
          @click="closePopup"
          class="bg-secondary rounded-lg font-semibold py-4 fsize14"
          >Cancel</vs-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    productDetail: {
      Type: Object,
    },
    AddAttribuitesShow: {
      Type: Boolean,
    },
  },
  data() {
    return {
      // attributeVal: [],
      // varientVal: "",
      // varientPrice: "",
      varientSKU: [],
      // varientDiscount: "",
      varientDiscountedPrice: "",
      // stock: "",

      ruleForm: {
        attributeVal: [],
        varientVal: "",
        varientPrice: "",
        varientDiscount: "",
        stock: "",
      },
      rules: {
        attributeVal: [
          {
            type: "array",
            required: true,
            message: "Please Select Attribute Value",
            trigger: "blur",
          },
        ],
        varientVal: [
          {
            required: true,
            message: "Please Enter Variation Vaue",
            trigger: "blur",
          },
        ],
        varientPrice: [
          {
            required: true,
            message: "Please Enter Price",
            trigger: "blur",
          },
          {
            pattern: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
            message: "Price must be Positive number",
            trigger: "blur",
          },
        ],
        varientDiscount: [
          // {
          //   // required: true,
          //   message: "Please Enter Discount ",
          //   trigger: "blur",
          // },
          {
            pattern: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
            message: "Discount must be Positive number",
            trigger: "blur",
          },
        ],
        stock: [
          {
            required: true,
            message: "Please Enter Stock Amount",
            trigger: "blur",
          },
          {
            pattern: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
            message: "Stock must be Positive number",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    // $data() {
    //   if (attributeVal == "" && varientVal == "") {
    //     varientSKU = [];
    //   }
    //   if (this.varientVal) {
    //     this.createSKU();
    //   }
    // },
    AddAttribuitesShow(val) {
      if (val) {
        this.resetForm("ruleForm");
      }
    },
    "ruleForm.attributeVal"() {
      this.createSKU();
    },
    "ruleForm.varientVal"() {
      this.createSKU();
    },
    "ruleForm.varientPrice"() {
      this.calDiscountedPrice();
    },
    "ruleForm.varientDiscount"() {
      this.calDiscountedPrice();
    },
  },
  methods: {
    handleSubmit(formName) {
      this.ruleForm.varientVal = this.ruleForm.varientVal.trim();
      this.ruleForm.varientPrice = this.ruleForm.varientPrice.trim();
      this.ruleForm.varientDiscount = this.ruleForm.varientDiscount.trim();
      this.ruleForm.stock = this.ruleForm.stock.trim();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.CreateVariation();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.ruleForm.varientPrice = "";
      this.varientSKU = "";
      this.ruleForm.varientVal = "";
      this.ruleForm.varientDiscount = "";
      this.varientDiscountedPrice = "";
      this.ruleForm.attributeVal = [];
      this.ruleForm.stock = "";
    },
    createSKU() {
      this.varientSKU = [];
      if (
        this.ruleForm.varientVal !== "" &&
        this.ruleForm.attributeVal !== ""
      ) {
        let productNameSKU = this.productDetail.productName
          .toUpperCase()
          .slice(0, 3);
        let productNameLength = this.productDetail.productName.length;
        let productVarientVal = this.ruleForm.varientVal
          .toUpperCase()
          .slice(0, 3);
        let productId = this.productDetail._id.toUpperCase().slice(-5);
        for (let data of this.ruleForm.attributeVal) {
          let productAttributeVal = data.toUpperCase().slice(0, 3);
          this.varientSKU.push({
            SKU: `${productNameSKU}-${productAttributeVal}-${productVarientVal}-${productId}`,
            attributeVal: data,
            productImageId: this.productDetail.productImageId.filter((x) => {
              if (x.valueName == data) {
                return x._id;
              }
            }),
          });
          // console.log(this.varientSKU);
        }
      }
    },
    async CreateVariation() {
      console.log(this.productDetail);
      console.log(this.varientSKU);
      const payload = {
        attributeId1: this.productDetail.attributesId._id,
        actualPrice: this.ruleForm.varientPrice,
        attributeValueNameAndSKU: this.varientSKU,
        variationValueName: this.ruleForm.varientVal,
        varientSKU: this.varientSKU,
        name: this.productDetail.attributesId[1].name,
        productId: this.productDetail._id,
        varientDiscount: this.ruleForm.varientDiscount,
        discountRate: this.varientDiscountedPrice,
        stock: parseInt(this.ruleForm.stock),
      };
      let data = await this.$store.dispatch(
        "EcomVariation/addVariation",
        payload
      );
      await this.$store.dispatch("EcomProduct/getAllProduct");
      this.$emit("closePopup");
      this.resetForm("ruleForm");
    },
    closePopup() {
      this.$emit("closePopup");
    },
    calDiscountedPrice() {
      let discount =
        (this.ruleForm.varientPrice / 100) * this.ruleForm.varientDiscount;
      console.log(discount);
      this.varientDiscountedPrice = this.ruleForm.varientPrice - discount;
    },
  },
};
</script>
<style>
.custelitem.el-form-item {
  margin-bottom: 10px !important;
}
</style>
